import { IconContext } from "react-icons";
import { FaSpinner } from "react-icons/fa";
import styled from "styled-components";
import Panel from "~/shared/Panel";
import Placeholder from "~/shared/Placeholder";

const StatsContainer = styled.div`
    p {
        color: ${({ theme }) => theme.color.base};
    }

    &:hover p {
        color: #fff;
    }

    &:hover .Panel {
        background-color: ${({ theme }) => theme.color.primary.background};
    }

    .metric {
        font-size: 3.5rem;
        line-height: 4rem;
        font-weight: bold;
    }

    .label {
        font-size: 1.25rem;
        line-height: 1.5rem;
    }

    & > div {
        padding-top: 2rem;
        padding-bottom: 2rem;
    }

    .confortPanel {
        display: flex;
        align-items: center;

        p:last-child{
            margin-left: 1rem;
        }

        @media(max-width: 980px){
            flex-direction: column;
            text-align: center;

            p:last-child{
            margin-left: 0;
        }
        }
    }
`;

type StatsPanel = {
    value: string;
    label: string | (() => JSX.Element);
    loading?: boolean;
};

const getLabelText = (label: string | (() => JSX.Element)) => {
    return typeof label === "string" ? label : label();
};

const StatsPanel = ({ value, label, loading = false }: StatsPanel) => {
    return (
        <StatsContainer>
            <Panel>
                <p className="metric">
                    {loading ? (
                        <span style={{ display: "block", marginBottom: "5px" }}>
                            <Placeholder maxWidth="45px" />
                        </span>
                    ) : (
                        value
                    )}
                </p>
                <p className="label">{loading ? <Placeholder /> : getLabelText(label)}</p>
            </Panel>
        </StatsContainer>
    );
};

export default StatsPanel;
